// Quando eu escrevi isso, só Deus e eu entendemos o que eu estava fazendo
// Agora, só Deus sabe

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMercadopago } from 'react-sdk-mercadopago'
import apiMercadoPago from '../../services/apiMercadoPago'
import { StoreState } from '../../store'
import PlanCard from './PlanCard'
import { getPayment } from '../../store/payments/paymentActions'
import { PaymentYear } from './PaymentYear'
import { PaymentMonthly } from './PaymentMonthly'
import { PaymentSemester } from './PaymentSemester'
import { PaymentSignature } from './PaymentSignature'

interface Props {
  months: string
  price: string
  total: string
  type: string
}

export default function PaymentDetails() {
  const [fadeIn, setFadeIn] = useState(false)
  const [summaryUnit, setSummaryUnit] = useState('')
  const [summaryTotal, setSummaryTotal] = useState('')
  const [summaryMonths, setSummaryMonths] = useState('')
  const [product, setProduct] = useState('')
  const [loading, setLoading] = useState(false)

  const mercadoPago = useMercadopago.v2(
    'APP_USR-248926ca-79b3-4dad-9e42-bd29ef080bd6',
    {
      locale: 'pt-BR',
    }
  )

  const { userEmail, userName, churchId, churchName, roles } = useSelector(
    ({ sessionState }: StoreState) => ({
      userName: sessionState.user?.name || '',
      churchId:
        sessionState.user?.churches[sessionState.selectedChurchIndex]?.id,
      userEmail: sessionState.user?.email || '',
      churchName:
        sessionState.user?.churches[sessionState.selectedChurchIndex]?.name,
      roles: sessionState.user?.roles || [],
    })
  )

  const { payment, isLoading } = useSelector(
    ({ paymentState }: StoreState) => ({
      payment: paymentState.payment,
      isLoading: paymentState.isLoading,
    })
  )

  const paymentMonthly = payment.filter(
    (item) => item.paymentType === 'monthly'
  )
  const paymentYearly = payment.filter((item) => item.paymentType === 'yearly')
  const paymentSignature = payment.filter(
    (item) => item.paymentType === 'signature'
  )
  const paymentSemester = payment.filter(
    (item) => item.paymentType === 'semester'
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPayment())
  }, [dispatch])

  const Pagar = async ({ months, price, total, type }: Props) => {
    setLoading(true)
    setSummaryMonths(months)
    setSummaryUnit(price)
    setSummaryTotal(total)
    setProduct(type)

    try {
      const { data } = await apiMercadoPago.post('create', {
        title: type,
        description: `${type} da ${churchName}`,
        quantity: '1',
        price: total,
        total,
        userEmail,
        userName,
        category_id: churchId,
        statement_descriptor: 'Igreja nas nuvens',
      })
      mercadoPagoCheckout(data.id)
      setFadeIn(true)
    } catch (e) {
      console.log('error', e)
    }
  }

  const mercadoPagoCheckout = (preference: string) => {
    if (mercadoPago) {
      mercadoPago.checkout({
        preference: {
          id: preference,
        },
        render: {
          container: '.cho-container',
          label: 'Pagar',
        },
      })
    }
  }

  return (
    <>
      <div
        style={{
          paddingTop: 20,
          width: '100%',
          height: '100vh',
          overflowY: 'scroll',
        }}
      >
        <main>
          {!fadeIn ? (
            <div className="shopping-cart">
              {isLoading || !paymentSignature[0] ? (
                ''
              ) : (
                <PaymentSignature
                  price={paymentSignature[0].price}
                  url={paymentSignature[0].urlSignature}
                />
              )}
              <div className="container flex flex-wrap pt-4 pb-10 m-auto mt-6 md:mt-15 lg:px-12 xl:px-16">
                <div className="w-full px-0 lg:px-4">
                  <h2
                    className="px-12 text-4xl font-bold text-center md:text-2xl "
                    style={{ color: '#3EB9F2' }}
                  >
                    Aproveite as nossas promoções pagando pelo site
                  </h2>

                  {roles.includes('pending') && (
                    <div>
                      <div className="flex flex-wrap items-center justify-center py-4 pt-0">
                        <PlanCard
                          title="Implantação"
                          price="300"
                          cents="00"
                          caption="Implantação e treinamento"
                          description={['Pagamento único']}
                          months="único"
                          cardColor="#1976D2"
                          buttonText={
                            <div className=" w-full h-full ">
                              {loading ? (
                                <div className="flex flex-col items-center justify-center w-full h-full  ">
                                  <button
                                    style={{ color: '#1976D2' }}
                                    className="w-5/6 py-2 mt-2 font-semibold   text-center uppercase bg-white rounded"
                                  >
                                    Aguarde...
                                  </button>
                                </div>
                              ) : (
                                <div className="flex flex-col items-center justify-center w-full h-full  ">
                                  <button
                                    style={{ color: '#1976D2' }}
                                    onClick={() =>
                                      Pagar({
                                        months: '1',
                                        price: '300.00',
                                        total: '300.00',
                                        type: 'implantação e treinamento',
                                      })
                                    }
                                    className="w-5/6 py-2 mt-2  font-semibold text-center uppercase bg-white rounded"
                                  >
                                    Adquirir
                                  </button>
                                </div>
                              )}
                            </div>
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div className="flex flex-wrap items-center justify-center py-4 pt-0">
                    {isLoading || !paymentMonthly[0] ? (
                      ''
                    ) : (
                      <PaymentMonthly
                        price={paymentMonthly[0].price}
                        total={paymentMonthly[0].total}
                        loading={loading}
                        Pagar={Pagar}
                      />
                    )}

                    {isLoading || !paymentSemester[0] ? (
                      ''
                    ) : (
                      <PaymentSemester
                        price={paymentSemester[0].price}
                        total={paymentSemester[0].total}
                        loading={loading}
                        Pagar={Pagar}
                      />
                    )}

                    {isLoading || !paymentYearly[0] ? (
                      ' '
                    ) : (
                      <PaymentYear
                        price={paymentYearly[0].price}
                        total={paymentYearly[0].total}
                        loading={loading}
                        Pagar={Pagar}
                      />
                    )}
                  </div>
                </div>
                <div className="w-full px-0 lg:px-4">
                  <div className="flex  flex-col justify-items-center pb-8">
                    <span className="text-xs  text-center text-gray-500">
                      Promoção válida para pagamento à vista*
                    </span>

                    <span className="text-xs  text-center text-gray-500">
                      Haverá um acréscimo de juros pela instituição financeira
                      para pagamento parcelado*
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <section className="payment-form dark">
              <div className="block-heading">
                <h2>Pagamento</h2>
                <p>Verifique se os dados estão corretos.</p>
              </div>
              <div className="flex  flex-col justify-items-center pb-8">
                <span className="text-xs font-bold text-center text-gray-500">
                  Promoção válida para pagamento a vista
                </span>

                <span className="text-xs font-bold text-center text-gray-500">
                  O pagamento parcelado haverá um acréscimo de juros
                </span>
              </div>
              <div className="form-payment">
                <div className="products">
                  <h2 className="title">Resumo</h2>
                  <div className="item">
                    <span className="price" id="summary-price"></span>
                    <p className="item-name">{product}</p>
                  </div>

                  <div className="total">
                    {summaryMonths === '1'
                      ? `Preço do item`
                      : `O valor de cada mês sairá por`}

                    <span className="price" id="summary-total">
                      R$ {summaryUnit}
                    </span>
                  </div>
                  <div className="total">
                    Você ir pagar um valor de{' '}
                    <span className="price" id="summary-total">
                      R$ {summaryTotal}
                    </span>
                  </div>
                </div>
                <div className="payment-details">
                  <div className="form-group col-sm-12"></div>
                </div>
              </div>
            </section>
          )}
          <section className="payment-form">
            <div className="form-payment">
              <div className="cho-container" />
            </div>
          </section>
        </main>
      </div>
    </>
  )
}
